import { SxProps, Theme } from "@mui/material";

export const additionalInformationStyles = {
    // additionalInfo Section Styles
    sectionHeader: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 700,
        fontSize: 24,
        mt: 2,
        mb: 2,
        fontFamily: theme.typography.fontFamily,
    }),
    label: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 400,
        fontSize: 15,
        mt: 2,
        mb: 0.5,
        fontFamily: theme.typography.fontFamily,
    }),
    textField: {
        fontSize: "15px",
        borderColor: "#595959",
        borderWidth: "1px",
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
        },
        "& .MuiOutlinedInput-input": {
            padding: "13px 15px",
        },
    },
    dropdownContainer: {
        position: "relative",
    },
    dropdownToggle: {
        display: "flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "#595959",
        borderWidth: "1px",
        borderRadius: "8px",
        padding: "13px 15px",
        justifyContent: "space-between",
    },
    selectedQuantityText: {
        flexGrow: 1,
        fontSize: "15px",
    },
    priceText: {
        mr: 2,
        fontSize: "15px",
    },
    dropdownMenu: (theme: Theme): SxProps<Theme> => ({
        width: "100%",
        position: "absolute",
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.15)",
        zIndex: 10,
        border: "1px solid #ccc",
        borderRadius: "4px",
        maxHeight: "200px",
        overflowY: "auto",
    }),
    dropdownItem: (theme: Theme): SxProps<Theme> => ({
        padding: "8px 12px",
        fontFamily: theme.typography.fontFamily,
        fontSize: "15px",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
    }),
    checkboxContainer: {
        display: "flex",
        alignItems: "flex-start",
        border: "1px solid #595959",
        borderRadius: "8px",
        padding: "8px",
        mb: "15px",
        "&:last-child": { mb: 0 },
    },
    checkbox: {
        mt: 1,
        "&.MuiCheckbox-root": {
            borderRadius: "4px",
            width: "25px",
            height: "25px",
        },
        "&.Mui-checked": {
            color: "#328734",
        },
    },
    checkboxContent: {
        ml: 1,
        flex: 1,
    },
    checkboxHeader: (theme: Theme): SxProps<Theme> => ({
        display: "flex",
        justifyContent: "space-between",
        fontFamily: theme.typography.fontFamily,
        fontWeight: 700,
        fontSize: 17,
    }),
    checkboxPrice: {
        ml: 1,
        fontWeight: 700,
        fontSize: 17,
    },
    checkboxDescription: {
        fontSize: 13,
        fontWeight: 400,
        lineHeight: "18.5px",
        letterSpacing: "0.203px",
    },
    // customerInfo Section Styles
    container: {
        maxWidth: "680px",
    },
    heading: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 600,
        fontSize: 22,
        mt: 3,
        fontFamily: theme.typography.fontFamily,
    }),
    requiredText: (theme: Theme): SxProps<Theme> => ({
        fontSize: 15,
        fontWeight: 400,
        fontFamily: theme.typography.fontFamily,
        color: "#595959",
        mb: 2,
    }),
    commentText: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 400,
        fontSize: 15,
        fontFamily: theme.typography.fontFamily,
    }),
    commentField: {
        mb: 2,
        borderColor: "#595959",
        borderWidth: "1px",
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
        },
    },

};
